export const techStackItems = [
  {
    name: "HTML5",
    icon: "🌐"
  },
  {
    name: "CSS3",
    icon: "🎨"
  },
  {
    name: "JavaScript",
    icon: "⚡"
  },
  {
    name: "Git",
    icon: "🔧"
  },
  {
    name: "Supabase",
    icon: "🚀"
  },
  {
    name: "MySQL",
    icon: "🗄️"
  },
  {
    name: "React",
    icon: "⚛️"
  },
  {
    name: "Node.js",
    icon: "🟢"
  },
  {
    name: "Python",
    icon: "🐍"
  },
  {
    name: "Docker",
    icon: "🐳"
  },
  {
    name: "AWS",
    icon: "☁️"
  },
  {
    name: "TypeScript",
    icon: "📘"
  }
];

// Alternative with more research-focused tools
export const researchTechStack = [
  {
    name: "Python",
    icon: "🐍"
  },
  {
    name: "R",
    icon: "📊"
  },
  {
    name: "MATLAB",
    icon: "🔬"
  },
  {
    name: "TensorFlow",
    icon: "🧠"
  },
  {
    name: "PyTorch",
    icon: "🔥"
  },
  {
    name: "Jupyter",
    icon: "📓"
  },
  {
    name: "Docker",
    icon: "🐳"
  },
  {
    name: "Git",
    icon: "🔧"
  },
  {
    name: "Linux",
    icon: "🐧"
  },
  {
    name: "PostgreSQL",
    icon: "🐘"
  },
  {
    name: "MongoDB",
    icon: "🍃"
  },
  {
    name: "AWS",
    icon: "☁️"
  }
];
